module.exports = __webpack_public_path__ + "img/icon-NavSettings-Gray.78e689fe.png";